import React from 'react';
import { Spinner } from 'react-bootstrap';

const BigSpinner = () => {
  return (
    <div className="d-flex justify-content-center">
      <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  )
}

export default BigSpinner;